import "./Home.module.css";
import AcostasLandscaping from "@/reusable_sections/Header";
import LawnPerfectionStartsHere from "./sections/LawnPerfectionStartsHere";
import TheArtOfTheEdge from "./sections/TheArtOfTheEdge";
import OurCoreServices from "./sections/OurCoreServices";
import RecentTransformations from "./sections/RecentTransformations";
import ReadyForAGreenerLawn from "./sections/ReadyForAGreenerLawn";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <AcostasLandscaping />
      <LawnPerfectionStartsHere />
      <TheArtOfTheEdge />
      <OurCoreServices />
      <RecentTransformations />
      <ReadyForAGreenerLawn />
      <SiteFooter />
    </div>;
}